export function waitForElement(
  elementFinder: () => HTMLElement | null | undefined,
  timeout = 1000,
  interval = 10,
): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    let timeoutRef: ReturnType<typeof setTimeout> | null = null;
    const intervalRef = setInterval(() => {
      const element = elementFinder();

      if (element) {
        if (timeoutRef !== null) {
          clearTimeout(timeoutRef);
        }

        clearInterval(intervalRef);
        resolve(element);
      }
    }, interval);
    timeoutRef = setTimeout(() => {
      clearInterval(intervalRef);
      reject(new Error('timeout'));
    }, timeout);
  });
}
